<template>
    <div class="activity-forms">
        <h2 class="activity-forms__title typographies-heading-h2">
            {{ $t.__('common.labels.activity') }}
        </h2>
        <div class="activity-forms__actions">
            <ActivityButton
                v-if="getFormById('email')"
                object="sent-email"
                :label="getFormById('email').label"
                :dataBot="getFormById('email').databot"
                @click="handleClick('email')"
            />
            <ActivitySplitButton
                v-if="getFormById('phonecall_scheduled') && getFormById('phonecall')"
                object="phone"
                :label="getFormById('phonecall_scheduled').label"
                :dataBot="getFormById('phonecall_scheduled').databot"
                :menuItems="[
                    {
                        label: getFormById('phonecall').label,
                        dataBot: getFormById('phonecall').databot,
                        action: () => handleClick('phonecall'),
                    },
                ]"
                :action="() => handleClick('phonecall_scheduled')"
            />

            <ActivityButton
                v-if="getFormById('task')"
                object="task"
                :label="getFormById('task').label"
                :dataBot="getFormById('task').databot"
                @click="handleClick('task')"
            />

            <ActivityButton
                v-if="getFormById('event')"
                object="calendar"
                :label="getFormById('event').label"
                :dataBot="getFormById('event').databot"
                @click="handleClick('event')"
            />
        </div>
        <h3 class="activity-forms__subtitle typographies-paragraph-medium-bold">
            {{ $t.__('common.labels.toComment') }}
        </h3>
        <AnnotationForm
            :isLoading="loading"
            :linkedtype="linkedtype"
            :linkedid="linkedid"
            :data="tmpForm.data"
        />
    </div>
</template>

<script>
import AnnotationForm from 'vcomponents/forms/AnnotationForm.vue';
import { buildUrl } from '../../../helpers';
import EmailMixins from 'mixins/EmailMixins';
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;
import Feature from 'Services/Feature';
import ActivityButton from 'vcomponents/common/activity/ActivityButton/ActivityButton.vue';
import ActivitySplitButton from 'vcomponents/common/activity/ActivitySplitButton/ActivitySplitButton.vue';
import { getOverviewLinkedType } from 'Helpers/overviewHelpers.js';

export default {
    components: {
        AnnotationForm,
        ActivityButton,
        ActivitySplitButton,
    },
    mixins: [EmailMixins],
    props: {
        linkedtype: {
            type: String,
            required: true,
        },
        linkedid: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            activeTab: [this.$l10n.__('Commenter')],
            forms: [
                {
                    id: 'annotation',
                    label: this.$l10n.__('Commenter'),
                    submitEvent: 'form:annotation:created',
                    url: '',
                    permission: true,
                    data: {},
                    databotKey: 'activitycommentadd',
                },
                {
                    id: 'email',
                    label: this.$t.__('common.actions.send_email'),
                    submitEvent: 'form:email:created',
                    permission: true,
                    data: {},
                    databotKey: 'emailadd',
                },
                {
                    id: 'phonecall_scheduled',
                    label: this.$t.__('common.actions.add_scheduled_phonecall'),
                    submitEvent: 'form:phonecall:created',
                    permission: false,
                    data: {},
                    databotKey: 'scheduledcalladd',
                },
                {
                    id: 'task',
                    label: this.$t.__('common.actions.add_scheduled_task'),
                    submitEvent: 'form:task:created',
                    permission: true,
                    data: {},
                    databotKey: 'taskadd',
                },
                {
                    id: 'event',
                    label: this.$t.__('common.actions.create_event'),
                    submitEvent: 'form:event:created',
                    permission: true,
                    data: {},
                    databotKey: 'eventadd',
                },
                {
                    id: 'phonecall',
                    label: this.$t.__('common.actions.add_phonecall'),
                    submitEvent: 'form:phonecall:created',
                    permission: false,
                    data: {},
                    databotKey: 'calladd',
                },
            ],
            loading: true,
            relatedData: {},
        };
    },
    computed: {
        formsEnabled() {
            return this.forms
                .filter((form) => form.data.enabled)
                .filter((form) => form.permission)
                .map((form) => {
                    form.databot =
                        this.databot && this.databot[form.databotKey]
                            ? this.databot[form.databotKey]
                            : false;
                    return form;
                });
        },
        tmpForm() {
            return this.forms.find((form) => form.id === 'annotation');
        },
        routes() {
            return this.$store.getters.routes;
        },
        databot() {
            return this.$store.getters.databots;
        },
        agendaViewConfig() {
            return this.$store.getters.agendaViewConfig;
        },
    },
    created() {
        this.fetch();
    },
    methods: {
        ...popupPanelMapActions(['open']),
        getFormById(id) {
            return this.formsEnabled.find((form) => form.id === id);
        },
        handleClick(value) {
            let linkedType = this.linkedtype;

            if (
                ['task', 'phonecall', 'phonecall_scheduled'].includes(value) ||
                (value === 'event' &&
                    Feature.isEnabled(
                        'activity-listing-crm-follow-up-deal-priotization-agenda-events',
                    ))
            ) {
                //We have to check if the feature is enabled because the linkedtype is not the same for apiv2
                if (Feature.isEnabled('activity-new-creation-panel')) {
                    if (['third', 'people'].includes(this.linkedtype)) {
                        linkedType = getOverviewLinkedType(linkedType).type;
                    }
                }
            }
            switch (value) {
                case 'annotation':
                    break;
                case 'task':
                    Activities.openActivityForm(
                        null,
                        this.linkedid,
                        linkedType,
                        function (data) {
                            window.EventBus.emit('timeline:processAndAdd', {
                                entity: 'task',
                                event: 'task.created',
                                objectid: data.id,
                            });
                        },
                        'task',
                    );
                    break;
                case 'event':
                    this.openCalendar();
                    break;
                case 'email':
                    this.checkIsEmailSetUp();
                    break;
                case 'phonecall':
                    Activities.openPhoneCallForm(
                        null,
                        this.linkedid,
                        linkedType,
                        function (data) {
                            window.EventBus.emit('timeline:processAndAdd', {
                                entity: 'phonecall',
                                event: 'phonecall.created',
                                objectid: data.id,
                            });
                        },
                        false,
                    );
                    break;
                case 'phonecall_scheduled':
                    Activities.openPhoneCallForm(
                        null,
                        this.linkedid,
                        linkedType,
                        function (data) {
                            window.EventBus.emit('timeline:processAndAdd', {
                                entity: 'phonecall',
                                event: 'phonecall.created',
                                objectid: data.id,
                            });
                        },
                        true,
                    );
                    break;
            }
        },
        checkIsEmailSetUp() {
            this.checkEmailProvider({}, { checkPrefill: true });
        },
        fetch() {
            const route = this.routes.find((route) => route.id === 'activityform');
            if (route) {
                this.$ajax.get(
                    buildUrl(route.value, [{ key: 'id', value: this.$store.getters.linkedid }]),
                    {},
                    (response) => {
                        this.forms.map((oneForm) => {
                            oneForm.data = response.tabs[oneForm.id];
                            if (oneForm.data.permission !== undefined) {
                                oneForm.permission = oneForm.data.permission;
                            }
                        });
                        this.loading = false;
                    },
                    () => {
                        this.close();
                        Push.error(
                            this.$l10n.__("Problème lors de la récupération de l'opportunité"),
                        );
                    },
                );
            }
        },
        openCalendar() {
            this.open({
                key: 'calendarView',
                props: {
                    relatedType: this.agendaViewConfig.relatedtype,
                    relatedId: this.linkedid,
                    nameCallbackFunction: this.agendaViewConfig.nameCallbackFunction,
                    prefixXsl: this.agendaViewConfig.prefixXsl,
                },
            });
        },
    },
};
</script>

<style scoped lang="scss">
.activity-forms {
    &__title {
        margin: 0 0 var(--spacing-3);
    }

    &__subtitle {
        margin: var(--spacing-3) 0 var(--spacing-1);
    }

    &__actions {
        display: flex;
        flex-wrap: wrap;
        gap: var(--spacing-1);
    }
}
</style>
